// extracted by mini-css-extract-plugin
module.exports = {"section":"OurCollection_section__QKvwU","title":"OurCollection_title__Kq_4H","swiperWrapper":"OurCollection_swiperWrapper__cwPID","scrollbar":"OurCollection_scrollbar__OtTxD"};